module.exports = __webpack_public_path__ + "static/media/IMG_3075.a435eb17.JPG";